<template>
    <div class="product-contents constrain flex">
        <div class="ff">
            <div class="flex product-search">
                <input type="text" placeholder="Search Book..." v-model="search" class="search" />
                <div class="ff"></div>
            </div>
            <toc :chapters="product.product_contents" :search="search" :exercises="true" />
        </div>
        <product-metadata :product="product" />
    </div>
</template>


<script>
    export default {
        name: 'ProductExercises',
        data(){
            return {
                loading: true,
                search: ''
            };
        },
        computed: {
            product(){
                return this.$store.getters.product;
            }
        },
        watch: {
            product: {
                immediate: true,
                handler(){
                    if(this.product){
                        if(this.product.product_contents){
                            return;
                        }

                        this.$store.dispatch('products/contents')
                        .catch(error => this.$toasted.error('There was an error loading the product contents.'))
                        .finally(() => this.loading = false);
                    }
                }
            }
        }
    }
</script>

<style scoped lang="less">
    @import "~@/assets/less/variables";

    .product-contents
    {
        padding: 50px;
    }

    .product-search
    {
        padding-bottom: 25px;
    }

    .search
    {
        max-width: 400px;
    }

    .product
    {
        padding: 40px 50px;
    }
</style>